import { Link } from 'found';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { injectIntl } from 'react-intl';

import Loading from 'src/components/Loading';
import Breadcrumbs from 'src/enosikit/components/Breadcrumbs';
import InviteAdminUserMutation from 'src/mutations/InviteAdminUserMutation';
import FlashesStore from 'src/stores/FlashesStore';

import AdminUserInviteAdminForm from './AdminUserInviteAdminForm';
import AdminUserControls from '../AdminUserControls';

class AdminUserInviteAdmin extends React.Component {
  static mutationName = 'inviteAdminUser';

  constructor(props) {
    super(props);

    this.state = {
      processing: false,
    };
  }

  handleAdminUserInviteAdmin = (input) => {
    this.setState({ processing: true });
    FlashesStore.reset();

    InviteAdminUserMutation(
      input,
      this.handleAdminUserInviteAdminSuccess,
      this.handleAdminUserInviteAdminFailure,
    );
  };

  handleAdminUserInviteAdminSuccess = (response, errors) => {
    this.setState({ processing: false });
    const { intl } = this.props;

    if (errors && errors.length > 0) {
      errors.forEach((error) => FlashesStore.flash(FlashesStore.ERROR, {
        message: FlashesStore.ERROR,
        source: {
          errors: [error],
        },
      }, AdminUserInviteAdmin.mutationName));
      return;
    }

    const { uuid, email } = response.inviteAdminUser;

    FlashesStore.flash(
      FlashesStore.SUCCESS,
      intl.formatMessage(
        {
          id: 'admin.admin_user.admin_user_invite_admin.response_message.success',
          defaultMessage: 'An email invitation has been sent to {emailLink} to finish their account registration.',
        },
        {
          emailLink: <Link to={`/admin/users/${uuid}`}>{`${email}`}</Link>,
        },
      ),
      AdminUserInviteAdmin.mutationName,
    );

    const { router } = this.props;
    router.push('/admin/users/');
  };

  handleAdminUserInviteAdminFailure = (error) => {
    this.setState({ processing: false });

    FlashesStore.flash(FlashesStore.ERROR, error, AdminUserInviteAdmin.mutationName);
  };

  render() {
    const { intl } = this.props;

    if (!this.props) {
      return <Loading />;
    }

    const { processing } = this.state;

    // Page title translations
    const pageTitle = intl.formatMessage({
      id: 'admin.admin_user.admin_user_invite_admin.page.title',
      defaultMessage: 'Enosi Admin - Users - Invite Admin',
    });

    // Breadcrumb translations
    const breadcrumbAdmin = intl.formatMessage({
      id: 'admin.admin_user.admin_user_invite_admin.breadcrumb.admin',
      defaultMessage: 'Admin',
    });
    const breadcrumbUsers = intl.formatMessage({
      id: 'admin.admin_user.admin_user_invite_admin.breadcrumb.users',
      defaultMessage: 'Users',
    });
    const breadcrumbInviteNewAdmin = intl.formatMessage({
      id: 'admin.admin_user.admin_user_invite_admin.breadcrumb.invite_new_admin',
      defaultMessage: 'Invite new admin',
    });

    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{pageTitle}</title>
        </Helmet>

        <Breadcrumbs
          breadcrumbs={[
            { name: breadcrumbAdmin, path: '/admin' },
            { name: breadcrumbUsers, path: '/admin/users' },
            { name: breadcrumbInviteNewAdmin },
          ]}
        />
        <div className="clearfix">
          <div className="float-end mb-3">
            <AdminUserControls />
          </div>
        </div>

        <AdminUserInviteAdminForm
          handleInvite={this.handleAdminUserInviteAdmin}
          processing={processing}
        />
      </>
    );
  }
}

AdminUserInviteAdmin.propTypes = {
  relay: PropTypes.shape({
    refetch: PropTypes.func,
  }).isRequired,
  router: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  intl: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default injectIntl(AdminUserInviteAdmin);
